import React from 'react';

const Discover = () => (
    <div className='flexbox row'>
        <span className='home-section-title'> Discover New Books </span>
        <span className='link-text'> More </span>
    </div>
);

export default Discover;